import React, { useEffect } from "react";
import { Link as RouterLink, useLocation } from "react-router-dom";
import {
  Avatar,
  Box,
  Divider,
  Drawer,
  Hidden,
  List,
  Typography,
} from "@mui/material";
import { BarChart as BarChartIcon, Users as UsersIcon } from "react-feather";
import NavItem from "./NavItem";
import NavItemdropdown from "./NavItemdropdown";
import PersonPinIcon from "@mui/icons-material/PersonPin";
import HeadsetMicIcon from "@mui/icons-material/HeadsetMic";
import ImageIcon from "@mui/icons-material/Image";

const user = {
  avatar: "/static/images/avatars/zippy.png",
  email: localStorage.getItem("email"),
  name: localStorage.getItem("user"),
};

var items = [
  {
    id: "Labs",
    title: "Labs",
    type: "group",
    children: [
      {
        href: "/app/runninglabs",
        icon: PersonPinIcon,
        title: "Running Labs",
      }
    ]
  },
  {
    id: "Management",
    title: "Management",
    type: "group",
    children: [
      {
        href: "/app/assessmentlist",
        title: "Assessment",
      },
      {
        href: "/app/judge",
        icon: UsersIcon,
        title: "Code Compiler",
      },
      {
        href: "/app/feedback",
        icon: UsersIcon,
        title: "Feedback",
      },
      {
        href: "/app/connectivitycheck",
        title: "Connectivity Test",
      },
    ]
  }
];

const DashboardSidebar = ({ onMobileClose, openMobile }) => {
  const location = useLocation();

  useEffect(() => {
    if (openMobile && onMobileClose) {
      onMobileClose();
    }
  }, [location.pathname]);

  const content = (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
      }}
    >
      <Box sx={{ p: 2 }}>
        <List>
          {items.map((item) => (
            <div>
              <Typography
                color="white"
                variant="caption"
                display="block"
                style={{ paddingTop: "7px" }}
              >
                {item.title}
              </Typography>
              <Divider style={{ backgroundColor: "rgb(6 57 108)" }} />
              {item.children.map((child) => {
                return (
                  <li className="px-3 rounded-lg mb-1 text-gray-700">
                    <NavItem
                      href={child.href}
                      key={child.title}
                      title={child.title}
                      icon={child.icon}
                      title1={item.title}
                      style={{ paddingTop: "3px" }}
                    />
                  </li>
                );
              })}
            </div>
          ))}
        </List>
      </Box>
      <Box sx={{ flexGrow: 1 }} />
      
      {/* Copyright Footer */}
      <Box
        sx={{
          p: 2,
          textAlign: 'center',
          borderTop: '1px solid',
          borderColor: 'rgba(255, 255, 255, 0.12)'
        }}
      >
        <Typography
          variant="caption"
          sx={{
            color: 'text.secondary',
            fontSize: '0.75rem'
          }}
        >
          © {new Date().getFullYear()} ZippyOPS Consulting Services LLP.
        </Typography>
      </Box>
    </Box>
  );

  const logout = () => {
    localStorage.clear();
    window.localStorage.clear();
    window.location.href = "/";
  };

  const content2 = (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
      }}
    >
      <Box
        sx={{
          alignItems: "center",
          display: "flex",
          flexDirection: "column",
          p: 2,
        }}
      >
        <Avatar
          component={RouterLink}
          src={user.avatar}
          sx={{
            cursor: "pointer",
            width: 64,
            height: 64,
          }}
          to="/app/profile"
        />
        <Typography
          // color="textPrimary"
          color="#ffff"
          // color="red"
          variant="h5"
        >
          {user.name}
        </Typography>
        <Typography color="#ffff" variant="body2">
          {user.email}
        </Typography>
      </Box>

      <Box sx={{ p: 2 }}>
        <List>
          {items.map((item) => (
            <div>
              <Typography
                color="white"
                variant="h6"
                style={{ paddingTop: "7px" }}
              >
                {item.title}
              </Typography>
              <Divider style={{ color: "white" }} />
              {item.children.map((child) => {
                return (
                  <li className="px-3 rounded-lg mb-1 text-gray-700">
                    {child.title === "LabList" ? (
                      <NavItemdropdown style={{ paddingTop: "3px" }} />
                    ) : (
                      <NavItem
                        href={child.href}
                        key={child.title}
                        title={child.title}
                        icon={child.icon}
                        style={{ paddingTop: "3px" }}
                      />
                    )}
                  </li>
                );
              })}
            </div>
          ))}
        </List>
      </Box>
      <Box sx={{ flexGrow: 1 }} />
      
      {/* Copyright Footer */}
      <Box
        sx={{
          p: 2,
          textAlign: 'center',
          borderTop: '1px solid',
          borderColor: 'rgba(255, 255, 255, 0.12)'
        }}
      >
        <Typography
          variant="caption"
          sx={{
            color: 'text.secondary',
            fontSize: '0.75rem'
          }}
        >
          © {new Date().getFullYear()} ZippyOPS Consulting Services LLP.
        </Typography>
      </Box>
    </Box>
  );

  return (
    <React.Fragment>
      <Hidden lgUp>
        <Drawer
          anchor="Right"
          onClose={onMobileClose}
          open={openMobile}
          variant="temporary"
          PaperProps={{
            sx: {
              width: 256,
              top: 60,
              backgroundColor: "rgb(0, 30, 60)",
            },
          }}
        >
          {content2}
        </Drawer>
      </Hidden>
      <Hidden lgDown>
        <Drawer
          anchor="left"
          open
          variant="persistent"
          PaperProps={{
            sx: {
              width: 256,
              top: 60,
              height: "calc(100% - 64px)",
              backgroundColor: "rgb(0, 30, 60)",
            },
          }}
        >
          {content}
        </Drawer>
      </Hidden>
    </React.Fragment>
  );
};

export default DashboardSidebar;
